// src/components/GameBoard.js
import React from 'react';
import { useGame } from '../contexts/GameContext';
import Market from './Market';
import PlayerHand from './PlayerHand';
import OpponentInfo from './OpponentInfo';
import ActionPanel from './ActionPanel';
import GameOver from './GameOver';
import GameStatus from './GameStatus';
import Card from './Card';
import './GameBoard.css';

function GameBoard() {
  const { gameState, error, leaveRoom, returnToLobby, selectedCards, selectCamel } = useGame();

  if (!gameState) {
    return (
      <div className="game-board">
        <div className="loading">加载游戏状态...</div>
      </div>
    );
  }

  const { status, self, opponent, market, is_my_turn } = gameState;

  // 生成骆驼数组用于渲染
  const camelCards = Array(self.camels).fill({ type: 'camel' });

  // 游戏结束
  if (status === 'finished') {
    return <GameOver gameState={gameState} onReturnToLobby={returnToLobby} />;
  }

  return (
    <div className="game-board">
      {error && (
        <div className="error-toast">{error}</div>
      )}

      <div className="game-header">
        <div className="turn-indicator">
          {is_my_turn ? (
            <span className="your-turn">你的回合 ⏱️</span>
          ) : (
            <span className="opponent-turn">对手回合 ⏳</span>
          )}
        </div>
        <button className="btn-leave" onClick={leaveRoom}>
          退出游戏
        </button>
      </div>

      <div className="game-container">
        {/* 左侧列 */}
        <div className="left-column">
          <OpponentInfo opponent={opponent} />
          <GameStatus gameState={gameState} />
        </div>

        {/* 中央区域 */}
        <div className="center-column">
          {/* 市场区域 */}
          <div className="market-section">
            <h3 className="section-title">市场</h3>
            <Market market={market} disabled={!is_my_turn} />
          </div>

          {/* 骆驼区域 */}
          <div className="camel-section-board">
            <h3 className="section-title">你的骆驼 ({self.camels})</h3>
            <div className="camel-cards-board">
              {self.camels > 0 ? (
                camelCards.map((card, index) => (
                  <Card
                    key={`camel-${index}`}
                    card={card}
                    selected={selectedCards.camels.includes(index)}
                    onClick={() => is_my_turn && selectCamel(index)}
                    disabled={!is_my_turn}
                    small
                  />
                ))
              ) : (
                <div className="empty-camels">暂无骆驼</div>
              )}
            </div>
          </div>

          {/* 玩家手牌 */}
          <div className="player-section">
            <h3 className="section-title">你的手牌</h3>
            <PlayerHand player={self} disabled={!is_my_turn} />
          </div>
        </div>

        {/* 操作面板 */}
        <ActionPanel disabled={!is_my_turn} />
      </div>
    </div>
  );
}

export default GameBoard;
